import {omneticApi} from '@dms/api/base';

import {
  GetMandatoryFieldsDefinitionApiArg,
  GetMandatoryFieldsDefinitionApiResponse,
  GetMandatoryFieldsDefinitionListApiArg,
  GetMandatoryFieldsDefinitionListApiResponse,
  GetStageSequenceMandatoryFieldsApiArg,
  GetStageSequenceMandatoryFieldsApiResponse,
  GetStageSequenceMandatoryFieldsListApiArg,
  GetStageSequenceMandatoryFieldsListApiResponse,
  SetStageSequenceMandatoryFieldsApiArg,
  SetStageSequenceMandatoryFieldsApiResponse,
} from './types';

export const mandatoryFieldsApi = omneticApi.injectEndpoints({
  endpoints: (build) => ({
    getMandatoryFieldsDefinition: build.query<
      GetMandatoryFieldsDefinitionApiResponse,
      GetMandatoryFieldsDefinitionApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/mandatory-fields/definition/${queryArg.definitionId}`,
      }),
    }),
    getMandatoryFieldsDefinitionList: build.query<
      GetMandatoryFieldsDefinitionListApiResponse,
      GetMandatoryFieldsDefinitionListApiArg
    >({
      query: () => ({
        url: `/dms/v1/mandatory-fields/definition`,
      }),
    }),
    getStageSequenceMandatoryFields: build.query<
      GetStageSequenceMandatoryFieldsApiResponse,
      GetStageSequenceMandatoryFieldsApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/mandatory-fields/definition/${queryArg.definitionId}/stage-sequence/${queryArg.stageSequenceId}`,
      }),
      providesTags: (_result, _error, queryArg) => [
        {type: 'MandatoryFields', id: `${queryArg.definitionId}-${queryArg.stageSequenceId}`},
      ],
    }),
    setStageSequenceMandatoryFields: build.mutation<
      SetStageSequenceMandatoryFieldsApiResponse,
      SetStageSequenceMandatoryFieldsApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/mandatory-fields/definition/${queryArg.definitionId}/stage-sequence/${queryArg.stageSequenceId}`,
        method: 'POST',
        body: queryArg.stageSequenceMandatoryFieldsRequestBody,
      }),
      invalidatesTags: (_result, _error, queryArg) => [
        {type: 'MandatoryFields', id: `${queryArg.definitionId}-${queryArg.stageSequenceId}`},
        {type: 'MandatoryFieldsSequence', id: `${queryArg.definitionId}`},
      ],
    }),
    getStageSequenceMandatoryFieldsList: build.query<
      GetStageSequenceMandatoryFieldsListApiResponse,
      GetStageSequenceMandatoryFieldsListApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/mandatory-fields/definition/${queryArg.definitionId}/stage-sequence`,
      }),
      providesTags: (_result, _error, queryArg) => [
        {type: 'MandatoryFieldsSequence', id: `${queryArg.definitionId}`},
      ],
    }),
  }),
});

export const {
  useGetMandatoryFieldsDefinitionQuery,
  useGetMandatoryFieldsDefinitionListQuery,
  useGetStageSequenceMandatoryFieldsQuery,
  useLazyGetStageSequenceMandatoryFieldsQuery,
  useSetStageSequenceMandatoryFieldsMutation,
  useGetStageSequenceMandatoryFieldsListQuery,
} = mandatoryFieldsApi;
